<!---------------------------->
<!-- Payment Buttons -->
<!---------------------------->

<div class="clearfix">
  <div class="flex justify-end align-center mt2 mb2">
    <ng-container *ngIf="isUserAllowedTo(PaymentTypeFamily.Duplicate)">
      <button mat-raised-button color="accent" style="margin-right: 16px;"
              data-qa="add-duplicate-payment"
              (click)="openPreAuthorisationPaymentDialog(null,$event, PaymentTypeOption.DuplicatePayment)">
        <mat-icon>add</mat-icon>
        Duplicate Payment
      </button>
    </ng-container>
    
    <button *ngIf="isUserAllowedTo(PaymentTypeFamily.Refund)" mat-raised-button color="accent"
            style="margin-right: 16px;"
            data-qa="add-refund-payment"
            (click)="openPreAuthorisationPaymentDialog(null,$event, PaymentTypeOption.UpfrontRefund)">
      <mat-icon>add</mat-icon>
      Refund
    </button>
    
    <button *ngIf="isUserAllowedTo(PaymentTypeFamily.Upfront)" mat-raised-button color="accent"
            style="margin-right: 16px;"
            data-qa="add-upfront-payment"
            (click)="openPreAuthorisationPaymentDialog(null,$event, PaymentTypeOption.UpfrontPayment)">
      <mat-icon>add</mat-icon>
      Upfront Payment
    </button>
    
    <button *ngIf="!paymentsByCaseId && isUserAllowedTo(PaymentTypeFamily.Payment)" mat-raised-button
            data-qa="add-payment-run"
            color="accent"
            [routerLink]="'/claim-management/execute-payment'">
      <mat-icon>add</mat-icon>
      Payment Run
    </button>
  </div>
</div>

<!---------------------------->
<!--Payment Search Filters-->
<!---------------------------->
<div class="header-container"
     [ngClass]="{'flex justify-end' : paymentsByCaseId}">
  <div *ngIf="!paymentsByCaseId" class="header-spacer">
    <mat-grid-list cols="5" rowHeight="65px"
                   data-qa="add-payments-filters">
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Search Payments</mat-label>
          <input matInput type="text" (input)="onInputChangedSearchPayments($any($event.target).value)">
        </mat-form-field>
        <mat-icon [matTooltip]="'Search by the payment reference or a comma-seperated list of payment IDs'"
                  class="info-icon">
          help_outline
        </mat-icon>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Policy</mat-label>
          <input matInput type="text"
                 [formControl]="policyFormControl"
                 (blur)="onBlurPolicySearch()"
                 (input)="onInputChangedSearchPolicies($any($event.target).value)"
                 [matAutocomplete]="policyAuto">
          <mat-autocomplete #policyAuto="matAutocomplete"
                            [panelWidth]="'40vw'"
                            (optionSelected)="onPolicySelected()">
            <mat-option *ngFor="let policy of filteredPolicies"
                        [value]="getPolicyDisplayString(policy)">
              {{getPolicyDisplayString(policy)}}
            </mat-option>
          </mat-autocomplete>
          <button *ngIf="policyFormControl.value" aria-label="Clear"
                  mat-button mat-icon-button matSuffix
                  (click)="clearPolicy()">
            <mat-icon style="color: grey;">clear</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Case</mat-label>
          <input matInput type="text"
                 [formControl]="caseFormControl"
                 (blur)="onBlurCaseSearch()"
                 (input)="onInputChangedSearchCases($any($event.target).value)"
                 [matAutocomplete]="caseAuto">
          <mat-autocomplete #caseAuto="matAutocomplete"
                            [panelWidth]="'40vw'"
                            (optionSelected)="onCaseSelected()">
            <mat-option *ngFor="let case of filteredCases"
                        [value]="getCaseDisplayString(case)">
              {{getCaseDisplayString(case)}}
            </mat-option>
          </mat-autocomplete>
          <button *ngIf="caseFormControl.value" aria-label="Clear"
                  mat-button mat-icon-button matSuffix
                  (click)="clearCase()">
            <mat-icon style="color: grey;">clear</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <app-element-select class="mr2"
                            displayLabel='Payment Type'
                            [defaultValue]="defaultPaymentType"
                            [options]="paymentTypeLookUpValues"
                            (selectionChanged)="onPaymentTypeSelectionChanged($event)">
        </app-element-select>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Payment Status</mat-label>
          <mat-select [(value)]="selectedStatus" (selectionChange)="statusSelectionChanged()">
            <mat-option *ngFor="let status of statuses" [value]="status">
              {{status}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
    
    </mat-grid-list>
  </div>
</div>


<ng-container *ngIf="isDataExist; else noPayments">
  
  <!---------------------------->
  <!-- Payments Table:-->
  <!---------------------------->
  
  <div class="mat-elevation-z8 table-container">
    <table mat-table multiTemplateDataRows matSort
           [dataSource]="paymentDataSource"
           (matSortChange)="sortData($event)">
      
      <!-- Icons -->
      <ng-container [matColumnDef]="TableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon (click)="openReportDialog(row,$event)" *ngIf="!isPreAuthorisationPayment(row)"
                    class="table-icon font-medium" matTooltip="VIEW Reports">arrow_downward
          </mat-icon>
          
          <ng-container *ngIf="isPreAuthorisationPayment(row)">
            
            <ng-container *ngIf="row?.paymentType?.name === PaymentTypeOption.DuplicatePayment">
              <!-- Duplicate Payment Icons-->
              <ng-container *ngTemplateOutlet="paymentIconTemplate; context: {
                            paymentType: PaymentTypeOption.DuplicatePayment,
                            paymentFamily: PaymentTypeFamily.Duplicate,
                            row: row,
                            isAllowed: isUserAllowedTo(PaymentTypeFamily.Duplicate)}">
              </ng-container>
            </ng-container>
            
            
            <ng-container *ngIf="row?.paymentType?.name === PaymentTypeOption.UpfrontRefund">
              <!--  Refund Payment Icons-->
              <ng-container *ngTemplateOutlet="paymentIconTemplate; context: {
                          paymentType: PaymentTypeOption.UpfrontRefund,
                          paymentFamily: PaymentTypeFamily.Refund,
                          row: row,
                          isAllowed: isUserAllowedTo(PaymentTypeFamily.Refund, PaymentTypeOption.UpfrontRefund)}">
              </ng-container>
            </ng-container>
            
            <ng-container *ngIf="row?.paymentType?.name === PaymentTypeOption.ClaimRefund">
              <ng-container *ngTemplateOutlet="paymentIconTemplate; context: {
                          paymentType: PaymentTypeOption.ClaimRefund,
                          paymentFamily: PaymentTypeFamily.Refund,
                          row: row,
                          isAllowed: isUserAllowedTo(PaymentTypeFamily.Refund, PaymentTypeOption.ClaimRefund)}">
              </ng-container>
            </ng-container>
            
            
            <ng-container *ngIf="row?.paymentType?.name === PaymentTypeOption.UpfrontPayment">
              <!-- Upfront Payment Icons-->
              <ng-container *ngTemplateOutlet="paymentIconTemplate; context: {
                          paymentType: PaymentTypeOption.UpfrontPayment,
                          paymentFamily: PaymentTypeFamily.Upfront,
                          row: row,
                          isAllowed: isUserAllowedTo(PaymentTypeFamily.Upfront)
                        }">
              </ng-container>
            </ng-container>
          </ng-container>
          
          
          <ng-template #paymentIconTemplate let-paymentType="paymentType" let-paymentFamily="paymentFamily" let-row="row" let-isAllowed="isAllowed">
            <ng-container
              *ngIf="row?.paymentType?.name === PaymentTypeOption.UpfrontRefund || row?.paymentType?.name === PaymentTypeOption.UpfrontPayment;">
              <mat-icon class="table-icon font-medium"
                        matTooltip="EDIT Payment"
                        (click)="openPreAuthorisationPaymentDialog(row, $event, row.paymentType.name)">edit
              </mat-icon>
              
              <!-- Show When valid roles-->
              <ng-container *ngIf="isAllowed">
                <ng-container *ngTemplateOutlet="showCancelAndReinstateIcon; context: { row: row }"></ng-container>
              </ng-container>
            </ng-container>
            
            
            
            <ng-container *ngIf="!(row?.paymentType?.name === PaymentTypeOption.UpfrontRefund || row?.paymentType?.name === PaymentTypeOption.UpfrontPayment)">
              <ng-container *ngIf="isAllowed">
                <mat-icon class="table-icon font-medium"
                          matTooltip="EDIT Payment"
                          (click)="openPreAuthorisationPaymentDialog(row, $event, paymentType)">
                  edit
                </mat-icon>
                
                <ng-container *ngTemplateOutlet="showCancelAndReinstateIcon; context: { row: row }"></ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
          
          <ng-template #showCancelAndReinstateIcon let-row="row">
            <ng-container *ngIf="showPaymentCancelButtons">
              <mat-icon *ngIf="row.isActive === 1"
                        class="table-icon font-medium"
                        matTooltip="CANCEL Payment"
                        (click)="clearPaymentClicked(row, $event)">
                clear
              </mat-icon>
              <mat-icon *ngIf="row.isActive === 0"
                        class="table-icon font-medium"
                        matTooltip="RE-INSTATE Payment"
                        (click)="reInstatePaymentClicked(row, $event)">
                check
              </mat-icon>
            </ng-container>
          </ng-template>
          
        </td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PaymentId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let row" mat-cell> {{row.paymentId}}</td>
      </ng-container>


      <ng-container [matColumnDef]="TableColumns.PaymentType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Type </th>
        <td *matCellDef="let row" mat-cell> {{row?.paymentType?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.IsImmediate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Immediate </th>
        <td *matCellDef="let row" mat-cell> {{isImmediatePayment(row) ? 'Y' : 'N'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PaymentReference">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Reference</th>
        <td *matCellDef="let row" mat-cell>
          <div class="flex justify-start items-baseline">
            <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                              (onClick)="openPaymentDialog($event, row)">
            </app-open-link-as>
            <p>{{row.paymentReference == null || row.paymentReference.trim() === '' ? 'update reference' : row.paymentReference}}</p>
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PaymentExecutionDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Execution Date</th>
        <td *matCellDef="let row" mat-cell> {{row.paymentExecutionDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PaymentCompletionDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Reference Completion Date</th>
        <td *matCellDef="let row" mat-cell> {{row.paymentCompletionDate | date: dateFormat}}</td>
      </ng-container>


      <ng-container [matColumnDef]="TableColumns.Amount">
        <th *matHeaderCellDef mat-header-cell> Amount</th>
        <td *matCellDef="let row" mat-cell> {{row.amount | number: '.2'}}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" mat-cell [attr.colspan]="paymentDisplayedColumns.length">
          <div class="row-detail-container" [@detailExpand]="row == paymentExpandedRow ? 'expanded' : 'collapsed'">
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="paymentDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: paymentDisplayedColumns;" class="row"
          [class.expanded-row]="paymentExpandedRow == row"
          (click)="paymentExpandedRow = paymentExpandedRow === row ? null : row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
    </table>

    <mat-paginator #paymentPaginator
                   [length]="paymentTableControl.length"
                   [pageSize]="paymentTableControl.pageSize"
                   [pageIndex]="0"
                   [pageSizeOptions]="paymentTableControl.pageSizeOptions"
                   (page)="pageChanged($event)">
    </mat-paginator>

  </div>
</ng-container>

<ng-template #noPayments>
  <div class="text-center mat-primary-color">
    <label class="column-label claim-column-label">No payment data</label>
  </div>
</ng-template>